import React, {FC, useLayoutEffect, useRef, useState} from 'react';
import styled from 'styled-components';

import {getNumberOfLinesOfTextForElement} from '../../../../../../libs/shared/helpers/src/browser/domHelpers';
import {fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {textSelection} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {ConversationSubjectContainer} from '../header/conversationSubjectContainer';

/*
 * Props.
 */

interface ConversationSummarySubjectProps {
  conversation: ConversationModel;
  teammateId: number;
}

/*
 * Styles.
 */

interface SubjectStyleProps {
  $shouldUseSmallerFontSize: boolean;
}
const StyledSubjectDiv = styled.div<SubjectStyleProps>`
  padding: 21px 20px 23px 20px;
  text-align: center;
  line-height: 28px;
  font-size: ${(p) => (p.$shouldUseSmallerFontSize ? '15px' : '18px')};
  font-weight: ${fontWeights.bold};
  overflow-wrap: break-word;
  ${textSelection()};

  /* Section Divider */
  border-bottom: 1px solid ${(p) => p.theme.greys.shade30};
`;

/*
 * Component.
 */

export const ConversationSummarySubject: FC<ConversationSummarySubjectProps> = ({
  conversation,
  teammateId,
}) => {
  const containerDiv = useRef<HTMLDivElement>(null);
  const [shouldUseSmallerFontSize, setShouldUseSmallerFontSize] = useState(false);

  useLayoutEffect(() => {
    const numLinesOfText: number | null =
      containerDiv.current && getNumberOfLinesOfTextForElement(containerDiv.current);
    const hasMoreThan3LinesOfText: boolean = numLinesOfText !== null && numLinesOfText > 3;

    setShouldUseSmallerFontSize(hasMoreThan3LinesOfText);
  }, [setShouldUseSmallerFontSize]);

  return (
    <StyledSubjectDiv ref={containerDiv} $shouldUseSmallerFontSize={shouldUseSmallerFontSize}>
      <ConversationSubjectContainer conversation={conversation} teammateId={teammateId} />
    </StyledSubjectDiv>
  );
};
